import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=c5d2995e&scoped=true&"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=c5d2995e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d2995e",
  null
  
)

export default component.exports